var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { RuleType } from "@@/Schema";
import { action, makeObservable, observable } from "mobx";
import { RuleUI, RuleParamUI, RuleParamUICondition, RuleParamUIConditionParam } from "./RuleBuilderStore";
export class FooterRuleUI {
    constructor() {
        this.name = "";
        this.rules = [];
        this.id = "";
        makeObservable(this);
    }
    setName(name) {
        this.name = name;
    }
    addRule(rule) {
        this.rules.push(rule);
    }
    removeRule(index) {
        this.rules.splice(index, 1);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleUI.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], FooterRuleUI.prototype, "rules", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleUI.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RuleUI]),
    __metadata("design:returntype", void 0)
], FooterRuleUI.prototype, "addRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], FooterRuleUI.prototype, "removeRule", null);
export class FooterRuleBuilderStore {
    constructor() {
        this.show = false;
        this.zindex = 0;
        this.rulecoid = "";
        this.activeruleid = "";
        this.footercolid = "";
        this.rules = [];
        this.activeruleindex = -1;
        this.activecontype = "schema";
        this.ruleByColumn = new Map();
        this.atciverule = undefined;
        this.saving = false;
        this.activeparam = "";
        this.activeparamui = undefined;
        this.activecondition = "and";
        this.activeparamitems = [];
        this.allfooterrules = new Map();
        this.newfooterrulename = "";
        makeObservable(this);
    }
    setActiveParamItems(items) {
        this.activeparamitems.splice(0, this.activeparamitems.length);
        this.activeparamitems.push(...items);
    }
    addNewRule() {
        if (!this.newfooterrulename.trim())
            return;
        const fr = new FooterRuleUI();
        fr.setName(this.newfooterrulename);
        fr.id = LetrwingCrypto.getUUID();
        this.allfooterrules.set(fr.id, fr);
        this.setRuleColId(fr.id);
        this.activefootrule = fr;
    }
    setNewFooterRuleName(name) {
        this.newfooterrulename = name;
    }
    setActiveConditionType(type) {
        this.activecondition = type;
    }
    setActiveParam(id) {
        this.activeparam = id;
    }
    setSaving(sav) {
        this.saving = sav;
    }
    addRule(rule) {
        var _a;
        (_a = this.activefootrule) === null || _a === void 0 ? void 0 : _a.addRule(rule);
    }
    setActiveConType(type) {
        this.activecontype = type;
    }
    setActiveRuleIndex(index) {
        this.activeruleindex = index;
    }
    deleteRule(id) {
        // lets remove this now!!
        for (let i = 0; i < this.rules.length; i++) {
            if (this.rules[i].id === id) {
                this.deleteRuleByIndex(i);
                break;
            }
        }
    }
    setActiveFooterColId(id) {
        this.footercolid = id;
    }
    deleteRuleChain(id) {
        this.allfooterrules.delete(id);
        if (this.rulecoid === id) {
            this.rulecoid = "";
        }
    }
    deleteRuleByIndex(index) {
        var _a;
        (_a = this.activefootrule) === null || _a === void 0 ? void 0 : _a.removeRule(index);
    }
    setZIndex(index) {
        this.zindex = index;
    }
    setShow(show) {
        this.show = show;
    }
    setRuleColId(id) {
        if (this.rulecoid === id)
            return;
        this.rulecoid = id;
        this.setActiveRuleId("");
        this.setActiveRuleIndex(-1);
        this.atciverule = undefined;
    }
    setActiveRuleId(id) {
        this.activeruleid = id;
    }
    clearRulesForCol(id) {
        this.ruleByColumn.delete(id);
        if (this.rulecoid === id) {
            this.rules.splice(0, this.rules.length);
            this.activeruleid = "";
        }
    }
    convertRuleUIsToRules() {
        const colrules = [];
        if (this.allfooterrules.size > 0) {
            const rules = Array.from(this.allfooterrules.values());
            for (const fr of rules) {
                colrules.push(this.convertFooterRuleUiToRule(fr, this.footercolid));
            }
        }
        return colrules;
    }
    convertRulesToRuleUIParam(rules) {
        var _a, _b;
        const ruleui = [];
        for (const r of rules) {
            const ru = new RuleUI(LetrwingCrypto.getUUID());
            ru.setType(r.type);
            ru.setPrevStageType((_a = r.prevstageresult) !== null && _a !== void 0 ? _a : r.type);
            if (r.conds) {
                for (const cc of r.conds) {
                    const cond = new RuleParamUICondition();
                    cond.setPrevCond(cc.prevtype);
                    cond.setCondition(cc.contype);
                    for (const ccp of cc.params) {
                        const ck = new RuleParamUIConditionParam();
                        ck.setComp(ccp.comp);
                        ck.setLeftCond(ccp.leftcond);
                        ck.setRightCond(ccp.rightcond);
                        ck.setRightSchemaCol(ccp.rightschemacon);
                        cond.addCondParam(ck);
                    }
                    ru.addRuleCond(cond);
                }
            }
            for (const rp of r.params) {
                const up = new RuleParamUI();
                if (rp.conds && rp.conds.length > 0) {
                    for (const cc of rp.conds) {
                        const cond = new RuleParamUICondition();
                        cond.setPrevCond(cc.prevtype);
                        cond.setCondition(cc.contype);
                        for (const ccp of cc.params) {
                            const ck = new RuleParamUIConditionParam();
                            ck.setComp(ccp.comp);
                            ck.setLeftCond(ccp.leftcond);
                            ck.setRightCond(ccp.rightcond);
                            ck.setRightSchemaCol(ccp.rightschemacon);
                            cond.addCondParam(ck);
                        }
                        up.addCondition(cond);
                    }
                }
                up.setActionForMatchingCond((_b = rp.matchingrow) !== null && _b !== void 0 ? _b : RuleType.Add);
                up.setType(rp.type);
                up.setValue(rp.value);
                ru.params.push(up);
            }
            ruleui.push(ru);
        }
        return ruleui;
    }
    reset() {
        this.ruleByColumn.clear();
        this.rulecoid = "";
        this.rules.splice(0, this.rules.length);
        this.activeruleid = "";
        this.activeruleindex = -1;
        this.atciverule = undefined;
        this.activecondition = "and";
        this.activecontype = "schema";
        this.activeparam = "";
        this.activeparamui = undefined;
        this.allfooterrules.clear();
        this.newfooterrulename = "";
    }
    setRules(rules) {
        var _a;
        this.reset();
        let fid = "";
        for (const rul of rules) {
            const cid = rul.colid;
            const uirules = this.convertRulesToRuleUIParam(rul.rule);
            const frule = new FooterRuleUI();
            frule.id = LetrwingCrypto.getUUID();
            for (const ur of uirules) {
                frule.addRule(ur);
            }
            frule.setName((_a = rul.name) !== null && _a !== void 0 ? _a : 'misisng');
            this.allfooterrules.set(frule.id, frule);
            if (!fid) {
                fid = frule.id;
            }
        }
        if (fid) {
            this.activefootrule = this.allfooterrules.get(fid);
            this.setRuleColId(fid);
        }
    }
    convertFooterRuleUiToRule(rui, id) {
        var _a;
        const srules = [];
        for (const r of rui.rules) {
            const rconds = [];
            if (r.ruleconds) {
                if (r.ruleconds.length > 0) {
                    for (const rc of r.ruleconds) {
                        if (rc.conditionparam.length > 0) {
                            const rcp = [];
                            for (const rcpp of rc.conditionparam) {
                                if (rcpp.comp) {
                                    const pp = {
                                        leftcond: rcpp.leftcondition,
                                        comp: rcpp.comp,
                                        rightcond: rcpp.rightcondition,
                                        rightschemacon: rcpp.rightschemacol
                                    };
                                    rcp.push(pp);
                                }
                            }
                            if (rcp.length > 0) {
                                rconds.push({
                                    contype: rc.condtype,
                                    prevtype: rc.prevresult,
                                    params: rcp,
                                });
                            }
                        }
                    }
                }
            }
            const myparsm = [];
            for (const rp of r.params) {
                const conds = [];
                if (rp.conds.length > 0) {
                    for (const rc of rp.conds) {
                        if (rc.conditionparam.length > 0) {
                            const rcp = [];
                            for (const rcpp of rc.conditionparam) {
                                if (rcpp.comp) {
                                    const pp = {
                                        leftcond: rcpp.leftcondition,
                                        comp: rcpp.comp,
                                        rightcond: rcpp.rightcondition,
                                        rightschemacon: rcpp.rightschemacol
                                    };
                                    rcp.push(pp);
                                }
                            }
                            if (rcp.length > 0) {
                                conds.push({
                                    contype: rc.condtype,
                                    prevtype: rc.prevresult,
                                    params: rcp,
                                });
                            }
                        }
                    }
                }
                myparsm.push({
                    type: rp.type,
                    value: rp.value,
                    conds: conds,
                    matchingrow: rp.addmatchingcond
                });
            }
            const myrule = {
                type: r.type,
                params: myparsm,
                conds: rconds,
                prevstageresult: (_a = r.prevstagerule) !== null && _a !== void 0 ? _a : r.type
            };
            srules.push(myrule);
        }
        const crule = {
            colid: id,
            rule: srules,
            name: rui.name
        };
        return crule;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleBuilderStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleBuilderStore.prototype, "zindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleBuilderStore.prototype, "rulecoid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleBuilderStore.prototype, "activeruleid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleBuilderStore.prototype, "footercolid", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], FooterRuleBuilderStore.prototype, "rules", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleBuilderStore.prototype, "activeruleindex", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], FooterRuleBuilderStore.prototype, "activecontype", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], FooterRuleBuilderStore.prototype, "ruleByColumn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleBuilderStore.prototype, "saving", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleBuilderStore.prototype, "activeparam", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleBuilderStore.prototype, "activecondition", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], FooterRuleBuilderStore.prototype, "activeparamitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], FooterRuleBuilderStore.prototype, "allfooterrules", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FooterRuleBuilderStore.prototype, "newfooterrulename", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setActiveParamItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "addNewRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setNewFooterRuleName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setActiveConditionType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setActiveParam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RuleUI]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "addRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setActiveConType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setActiveRuleIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "deleteRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setActiveFooterColId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "deleteRuleChain", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "deleteRuleByIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setZIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setRuleColId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setActiveRuleId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "clearRulesForCol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "convertRuleUIsToRules", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], FooterRuleBuilderStore.prototype, "setRules", null);
